var about;

about = function() {
  var $, Parallax, moduleName, parallax, scene;
  $ = require('jquery');
  Parallax = require('parallax-js');
  moduleName = 'about';
  scene = $("#" + moduleName + "--tree-parallax").get(0);
  if (scene) {
    return parallax = new Parallax(scene);
  }
};

module.exports = about;
